import React from "react";
import { connect } from 'react-redux';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import Filter from './Filter';
import moment from "moment";
import { actions } from '../query/store';

const monthFormat = 'YYYY-MM';
const DefaultSearchParams = {
    monthNum1: moment().format(monthFormat),
    monthNum2: moment().format(monthFormat),
};

class MonthlyFte extends React.Component {
    state = {
        searchParams: { ...DefaultSearchParams },
        data: [],
        businessList: [],
        loading: false,
    }

    componentDidMount() {
        const { searchParams: propSearchParams } = this.props;
        const { searchParams } = this.state;
        const { monthNum1, monthNum2 } = searchParams;
        const { startDate, endDate } = propSearchParams;
        this.setState({
            searchParams: {
                ...searchParams,
                ...propSearchParams,
                monthNum1: startDate || monthNum1,
                monthNum2: endDate || monthNum2,
            }
        }, () => {
            this.loadData();
        });
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { searchParams } = this.state;
        const userId = this.props.match ? this.props.match.params.name : null;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.manhour.caculateMonthlyFte}`,
            data: {
                offset: 1,
                userId,
                ...searchParams,
            },
            type: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        this.loadData();
    }

    reset = () => {
        this.setState({ searchParams: {...DefaultSearchParams} }, () => {
            this.loadData();
        });
    }

    handleSearchChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index ',
        width: 60,
        fixed: 'left',
    }, {
        title: '时间',
        dataIndex: 'monthNum',
        key: 'monthNum',
        width: 80,
        fixed: 'left',
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 120,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 240,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 100,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 100,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 100,
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 120,
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 80,
    }, {
        title: '城市',
        dataIndex: 'cityName',
        key: 'cityName',
        width: 80,
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 80,
    }, {
        title: '计划FTE',
        dataIndex: 'planFte',
        key: 'planFte',
        width: 80,
    }, {
        title: '实时消耗FTE',
        dataIndex: 'cusmerActualFte',
        key: 'cusmerActualFte',
        width: 100,
    }, {
        title: '确认消耗FTE',
        dataIndex: 'cusmerFte',
        key: 'cusmerFte',
        width: 100,
    }]

    getDataSource = () => {
        const result = [];
        const { data } = this.state;
        let monthIndex = 1;
        data.map((manhour, i) => {
            const result_temp = {};
            if (manhour.manHourId == null || manhour.manHourId == undefined) {
                monthIndex = 0;
                if (manhour.isCounting == 'TOTAL') {
                    result_temp["index"] = "总计";
                } else {
                    result_temp["index"] = "月合计";
                }
            } else {
                result_temp["index"] = monthIndex;
            }
            result_temp["monthNum"] = manhour.dateString;
            if (manhour.enterpriseWorkCategoryCode && manhour.enterpriseWorkCategoryCode != null) {
                result_temp["investigationCode"] = manhour.enterpriseWorkCategoryCode;
            } else {
                result_temp["investigationCode"] = manhour.investigationCode;
            }
            if (manhour.enterpriseWorkCategoryName && manhour.enterpriseWorkCategoryName != null) {
                result_temp["investigationName"] = manhour.enterpriseWorkCategoryName;
            } else {
                result_temp["investigationName"] = manhour.investigationName;
            }
            result_temp["investigationSiteCode"] = manhour.investigationSiteCode;
            result_temp["investigationSiteName"] = manhour.investigationSiteName;
            result_temp["roleCode"] = manhour.roleCode;
            result_temp["planFte"] = manhour.planFte;
            result_temp["cusmerActualFte"] = manhour.cusmerActualFte;
            result_temp["cusmerFte"] = (manhour.cusmerFte == 0 || manhour.cusmerFte == null) ? null : manhour.cusmerFte.toFixed(2);
            result_temp["lineOfBusinessString"] = manhour.lineOfBusinessString;
            result_temp["secondLineNames"] = manhour.secondLineNames;
            result_temp["areaName"] = manhour.areaName;
            result_temp["cityName"] = manhour.cityName;
            result_temp["investigationAreaName"] = manhour.investigationAreaName;
            result_temp["diseaseName"] = manhour.diseaseName;
            if (manhour.manHourId == null || manhour.manHourId == undefined) {

                result_temp["fteAllowance"] = Number(manhour.monthFteAllowance).toFixed(2);
            } else {
                result_temp["fteAllowance"] = '-';
            }
            monthIndex += 1;
            result.push(result_temp);
        });
        return result;
    }

    goBack = () => {
        this.props.updateUseState();
        history.back();
    }

    render() {
        const { loading, businessList, searchParams } = this.state;
        const scrollY = document.documentElement.clientHeight - 120;
        return (
            <div className="content">
                <SideNav selectKey="monthlyFte" />
                <div className="main">
                    <div className="T-tit">
                        <Filter
                            reset={this.reset}
                            search={this.search}
                            goBack={this.goBack}
                            businessList={businessList}
                            searchParams={searchParams}
                            onChange={this.handleSearchChange}
                            showback={this.props.match ? true : false}
                        />
                        <TableC
                            loading={loading}
                            columns={this.getColumns()}
                            data={this.getDataSource()}
                            scrollY={scrollY}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    searchParams: state.manHourState.query.searchParams
});

const mapDispatchToProps = (dispatch) => ({
    updateUseState: () => dispatch(actions.updateUseState())
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyFte);



// WEBPACK FOOTER //
// ./src/components/manHour/monthlyFte/index.js